// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__zrIPv","range":"MonthRangeSwitch_range__2CXdz","disabled":"MonthRangeSwitch_disabled__11sli"};